import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import notify from '@scoutgg/ftw/source/services/notification'
import query from '../../services/query'
import normalize from '../../../helpers/normalize'
import template from './gameweeks.jade'
import { Season, Match } from '../../models'
import '../seasons'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
class Gameweeks extends HTMLElement {
  attached() {
    this.lockedGameweeks = false
    Season.load({ active: true }).then(({ seasons }) => {
      const sport = this.season?.sport
      const sports = Array.from(new Set(seasons.map(season => season.sport)))
      this.applyState({ seasons, sport, sports })
      this.reload()
    })
  }

  seasonChange() {
    this.reload()
  }

  changeSeason({ season }) {
    query({ season })
  }

  changeSport(sport) {
    this.applyState({ sport })
  }

  addRound(match) {
    var shouldAdd = false
    for(const m of this.realMatches) {
      if(m === match) shouldAdd = true
      if(!shouldAdd) continue
      m.round++
    }
    this.render()
  }

  removeRound(round) {
    for(const m of this.realMatches) {
      if(m.round < round) continue
      m.round--
    }
    this.render()
  }

  auto() {
    const distance = 72 * 60 * 60 * 1000
    var round = 0
    var time = 0
    for(const m of this.realMatches) {
      if(+m.startTime - time > distance) {
        round++
        time = +m.startTime
      }
      m.round = round
    }
    this.render()
  }

  reset(round) {
    for(const m of this.realMatches) {
      m.round = 1
    }
    this.render()
  }

  reload() {
    if(!this.season) return
    var params = {
      $reload: true,
      season: this.season._id,
    }
    this.lockedGameweeks = this.season?.lockedGameweeks
    Match.load(params).then(({ matches }) => {
      this.applyState({
        realMatches: matches
          .filter(m => m.round > 0)
          .filter(m => +m.startTime)
          .sort((a, b) => {
            return (+a.startTime - +b.startTime) || (a.round - b.round)
          }),
      })
    })
  }
  changeGWLockStatus() {
    this.lockedGameweeks = !this.lockedGameweeks
    const lockedGameweeks = this.lockedGameweeks
    this.season.post('lock', {
      lockedGameweeks,
    })
      .then(() => {
        notify('Lock status is now: ' + this.lockedGameweeks, { level: 'success', timeout: 5000 })
      })
      .catch(err => {
        console.error(err)
        notify(err.message, { level: 'danger', timeout: 10000 })
      })
      .then(() => {
        this.$isSubmitting = false
        this.reload()
        this.render()
      })
  }
  save() {
    this.$isSubmitting = true
    const matchRounds = this.realMatches.reduce((obj, m) => {
      obj[m._id] = m.round
      return obj
    }, {})

    this.season.post('rounds', { matchRounds })
      .then(() => {
        notify('Rounds updated', { level: 'success', timeout: 5000 })
      })
      .catch(err => {
        console.error(err)
        notify(err.message, { level: 'danger', timeout: 10000 })
      })
      .then(() => {
        this.$isSubmitting = false
        this.render()
      })
    this.render()
  }

  send(season, type) {
    if(season.$isSubmitting) return
    season.$isSubmtting = true
    season.post(`send-${type}`).then(() => {
      notify(`Sending of ${type} is completed`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, { level: 'danger', timeout: 1000 })
    }).then(() => {
      season.$isSubmitting = false
      this.render()
    })
    this.render()
  }
}

export default Gameweeks
